import { FormControlLabel } from "@mui/material";
import { observer } from "mobx-react-lite";
import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import BriaCheckbox from "../../../../../../components/common/BriaCheckbox/BriaCheckbox";
import BriaSlider from "../../../../../../components/common/BriaSlider/BriaSlider";
import { IMAGE_REFERENCE_CONFIGS } from "../../../../../../constants/TextToImageConstants";
import { useAppStore } from "../../../../../../hooks/useStores";

const TgInfluenceSlider = () => {
	const { t } = useTranslation("translation", { keyPrefix: "newTg.app.image.config.models" });
	const { textToImageStore } = useAppStore();
	const { config, handleConfigChange } = textToImageStore;

	const handleFastCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
		handleConfigChange("fast", e.target.checked);
		handleConfigChange(
			"steps_num",
			e.target.checked
				? IMAGE_REFERENCE_CONFIGS.steps.fast.default
				: IMAGE_REFERENCE_CONFIGS.steps.not_fast.default,
		);
	};

	return (
		<>
			<BriaSlider
				value={config.tailored_model_influence}
				onChange={(_, value) => handleConfigChange("tailored_model_influence", value as number)}
				step={0.05}
				min={0}
				max={1}
				marks={[
					{ value: 0, label: t("influence.low") },
					{ value: 1, label: t("influence.high") },
				]}
				valueLabelDisplay="auto"
				labelsAlwaysGray
			/>
			{config.training_version === "light" && (
				<FormControlLabel
					control={
						<BriaCheckbox
							disabled={config.restyle_portrait}
							checked={config?.fast}
							onChange={handleFastCheckboxChange}
						/>
					}
					label={t("fast")}
				/>
			)}
		</>
	);
};

export default observer(TgInfluenceSlider);
